module.exports = __webpack_public_path__ + "assets/hardware-type-role.e10e9773.svg";